import { render, staticRenderFns } from "./reservedList.vue?vue&type=template&id=6c2ab5ee&scoped=true&"
import script from "./reservedList.vue?vue&type=script&lang=js&"
export * from "./reservedList.vue?vue&type=script&lang=js&"
import style0 from "./reservedList.vue?vue&type=style&index=0&id=6c2ab5ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ab5ee",
  null
  
)

export default component.exports